import angular from 'angular';

class GlobalSettingListCtrl {
    /*@ngInject*/
    constructor($state, logger, AuthSvc, $uibModal, $scope, GlobalSettingSvc) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.globalSettingSvc = GlobalSettingSvc;
    }

    $onInit() {
        this.globalSettings = [];
        this.globalSettingSvc.getAllGlobalSetting().then(
            res => {
                this.initialAnnuairePpfMode = res.value
                this.annuairePpfMode = res.value;
            }
        );
    }

    preparePpfMofe() {
        return {
            name: 'annuaire.pff.setting',
            value: this.annuairePpfMode
        };
    }

    sendSettings() {
        this.globalSettingSvc.saveGlobalSetting(this.preparePpfMofe()).then(() => {
            this.logger.success('global_setting.message.success');
            this.$onInit();
        }).catch(()=> this.logger.error('global_setting.message.error'));
    }

    cancelSetting() {
        this.annuairePpfMode = angular.copy(this.initialAnnuairePpfMode);
    }

}

angular.module('app.global_setting').component('globalSettingList', {
    templateUrl: require('./global-setting.html'),
    controller: GlobalSettingListCtrl
});



